<div class="dropdown">
  <button class="btn btn-lg secondary borderless" [ngClass]="{'active': isActive}" type="button" id="dropdownMenu1"
    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
    <span><img src="../../../assets/icon/settings-gear-65.svg"></span>
  </button>


  <div class="dropdown-menu dropdown-menu-right allow-focus full ">

    <div class="row pt-2 pb-2 ml-1 mr-1  vertical-align">
      <div class="col-9 d-flex">
        <span class="title center" i18n="dropdown_filler|@@view">Probabilité<br/>/ Vue</span>
      </div>
      <div class="col-3">
        <div class="parameters-toggle">
          <app-generic-toggle  (sendData)="damageFilterService.damageFilterValue = $event; onEdit()" [value]="damageFilterService.damageFilterValue" ></app-generic-toggle>
        </div>
      </div>
    </div>

    <div class="container m-0 p-0 max">
      <div class="row m-0 p-0" *ngIf="damageFilterService.damageFilterValue">
        <div class="col-12 mt-1 p-0">
          <div class="container">
            <div class="row">
              <div class="col-sm">
                <span i18n="annotation|@@type">Type</span>
              </div>
              <div class="col-sm">
                <span i18n="annotation|@@probability">Probabilité</span>
              </div>
              <div class="col-sm">
                <span i18n="annotation|@@view">Vue</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-1 p-0" *ngFor="let item of filterShow">
          <div class="container">
            <div class="row">
              <div class="col-sm m-0 ">
                <span>{{item.type | vehicleDamage}}</span>
              </div>
              <div class="col-sm m-0 p-0 ">
                <input type="number" min="50" max="100" [ngModel]="item.proba"
                  (ngModelChange)="change('proba', item.type, $event)" />
              </div>
              <div class="col-sm m-0">
                <input type="number" min="1" [ngModel]="item.number"
                  (ngModelChange)="change('number', item.type, $event)" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="container">
            <div class="row">
              <div class="col-6 mt-1">
                <button type="button" class="btn btn-block secondary" (click)="reset()">
                  <span class="text-span">Reset</span>
                </button>
              </div>
              <div class="col-6 mt-1">
                <button type="button" class="btn btn-block primary longSubmit" (click)="save()">Save U</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-2 pb-2  ml-1 mr-1 vertical-align">
      <div class="col-8 d-flex">
        <span class="title center" i18n="annotation|@@parent">Parent </span>
      </div>
      <div class="col-4">
        <div class="parameters-toggle">
          <app-generic-toggle  (sendData)="damageFilterService.damageFilterParent = $event; onEdit()" [value]="damageFilterService.damageFilterParent" ></app-generic-toggle>
        </div>
      </div>
    </div>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/dropdown-filter-damage/dropdown-filter-damage.component.html